import React, {Component} from "react";

class Links extends Component{
    render(){
        return(
            <main>
                <h2>my links</h2>
                <ul>
                    <li><a href="https://ia-ia-ia.world">IA IA IA.</a> I'm hosting my comics here.</li>
                    <li>A few different galleries I rigged up for my (and some friends') tabletop role-playing games.
                        <ul>
                            <li><a href="https://snaplands.edsite.black">South of Snaplands</a>, my current game.</li>
                            <li><a href="https://gradia.edsite.black">Tails of Gradia</a>, the game I originally designed this for.</li>
                            <li><a href="https://bsbs.edsite.black">Blue Skies, Black Smoke</a>, a game gone too soon from this cruel world.</li>
                            <li><a href="https://scalesagas.edsite.black">Scalesagas</a>, my good friend's (absolutely enourmous) game.</li>
                        </ul>
                    </li>
                </ul>
                <h2>other links</h2>
                <ul>
                    <li><a href="https://tigers.best">My friend Jade's site.</a></li>
                </ul>
                <h2>games</h2>
                <p>I used to publish tabletop games and related materials on <a href="https://bone-mouse.itch.io">Itch.</a></p>
                <iframe className="itchFrame" title="Escherian" src="https://itch.io/embed/747594?linkback=true&amp;bg_color=222222&amp;fg_color=eeeeee&amp;border_color=363636"  frameBorder="0"><a href="https://bone-mouse.itch.io/escherian-industrial-revolution">Escherian Industrial Revolution by Bone Mouse Productions</a></iframe><br />
                <iframe className="itchFrame" title="Carrow" src="https://itch.io/embed/804581?linkback=true&amp;bg_color=222222&amp;fg_color=eeeeee&amp;border_color=363636" frameBorder="0"><a href="https://bone-mouse.itch.io/the-carrow-cookbook">The Carrow Cookbook (Second Edition) by Bone Mouse Productions</a></iframe>
            </main>
        );
    }
}

export default Links;